import { Pipe, PipeTransform } from '@angular/core';
import { IndividualExtendedModel } from '@spa/api';
import { Helper } from '../classes';
import { LanguageService } from '../language.service';

@Pipe({
  name: 'individualGreeting',
  pure: true
})
export class IndividualGreetingPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(value: IndividualExtendedModel): string {
    const language = this.languageService.getCurrentLanguage();

    return Helper.textsHelper().getIndividualGreeting(value, language);
  }
}
